import React from "react";
import Contactus from "../components/Contact/Contact"; 
import Banner from '../comman/Banner/Banner';


const Contact = () => {
  return (
    <>
    <Banner 
     index={'contact'}
    />
    <Contactus/>    
    </>

  )
};

export default Contact;